<div  class="text-center page-container">

    <iframe id="iframe" [src]="legacyAddPrefix" style="width: 100%; height: 100%"></iframe>
</div>
